var React = require('react');

function ThreeDotsIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .three-dots-icon-svg {\n        fill: #bebebe;\n        fill-rule: evenodd;\n      }\n    ")),React.createElement("path",{"id":"Ellipse_2_copy_2","data-name":"Ellipse 2 copy 2","className":"three-dots-icon-svg","d":"M493.5,23a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,493.5,23Zm0,6a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,493.5,29Zm0,6a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,493.5,35Z","transform":"translate(-492 -23)","key":1})]);
}

ThreeDotsIcon.defaultProps = {"width":"3","height":"15","viewBox":"0 0 3 15"};

module.exports = ThreeDotsIcon;

ThreeDotsIcon.default = ThreeDotsIcon;
